import React, { useEffect, useRef, useState } from "react";
import { V_URL_API } from "../../../../../../../../utils/config";
import TooltipText from "../../../../../../../../components/TooltipText/TooltipText";

export default function BotonRecurso({ recurso, getToken }) {
  console.log(recurso);
  const [loadingId, setLoadingId] = useState(null);

  const [vIsHover, setVIsHover] = useState(false);
  const vRef = useRef(null);

  useEffect(() => {
    const textoContenedor = vRef.current;
    if (textoContenedor) {
      const maxScrollLeft = textoContenedor.scrollWidth - textoContenedor.clientWidth;
      const targetScroll = vIsHover ? maxScrollLeft : 0;
      const cancelAnimation = moveScrollTo(textoContenedor, targetScroll, 1); // Reduced speed for slower scrolling

      return () => cancelAnimation(); // Cleanup on effect re-run
    }
  }, [vIsHover]);

  const handleDownload = async (idRecurso, nombre) => {
    const url = `${V_URL_API}/api/descargar_recurso/${idRecurso}?_t=${Date.now()}`;
    setLoadingId(idRecurso);

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `E ${getToken}`,
        },
      });

      if (!response.ok) throw new Error("Error al descargar recurso");

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = nombre || "recurso.pdf"; // Fallback
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error al descargar:", error);
      alert("Hubo un problema al descargar el recurso.");
    } finally {
      setLoadingId(null);
    }
  };

  const moveScrollTo = (element, targetScroll, speed) => {
    let animationFrameId; // Store the animation frame ID

    const move = () => {
      const currentScroll = element.scrollLeft;
      const distance = targetScroll - currentScroll;
      const step = Math.sign(distance) * Math.min(Math.abs(distance), speed);

      if (Math.abs(distance) <= Math.abs(step)) {
        element.scrollLeft = targetScroll; // Snap to the target position
        cancelAnimationFrame(animationFrameId); // Stop animation
      } else {
        element.scrollLeft += step;
        animationFrameId = requestAnimationFrame(move); // Continue animation
      }
    };

    // Start the animation
    animationFrameId = requestAnimationFrame(move);

    // Cleanup function to cancel animation if `vIsHover` changes
    return () => cancelAnimationFrame(animationFrameId);
  };

  const handleMouseEnter = (e) => {setVIsHover(true);};

  const handleMouseLeave = (e) => {
    setVIsHover(false);
  };
  return (
    <div
    vText={"Recurso descargable"}
      key={recurso.id_recurso}
      className={
        recurso.tipo_recurso === 0
          ? "recurso-video"
          : recurso.tipo_recurso === 1
          ? "recurso-infografia"
          : recurso.tipo_recurso === 2
          ? "recurso-presentacion"
          : recurso.tipo_recurso === 3
          ? "recurso-excel"
          : recurso.tipo_recurso === 4
          ? "recurso-documento"
          : ""
      }
      onClick={() => handleDownload(recurso.id_recurso, recurso.nombre_recurso)}
      onMouseEnter={handleMouseEnter} // Evento de pasar el mouse
      onMouseLeave={handleMouseLeave} // Evento cuando el mouse sale
    >
      {/* Íconos según el tipo de recurso */}
      {recurso.tipo_recurso === 0 && (
        <i className="fi fi-rr-video-camera-alt video-camera-alt-2"></i>
      )}
      {recurso.tipo_recurso === 1 && <i className="fi fi-rs-stats stats-2"></i>}
      {recurso.tipo_recurso === 2 && (
        <i className="fi fi-rr-dashboard-monitor dashboard-monitor-2"></i>
      )}
      {recurso.tipo_recurso === 3 && (
        <i className="fi fi-rr-file-edit file-edit-3-2"></i>
      )}
      {recurso.tipo_recurso === 4 && (
        <i className="fi fi-rr-folder-open fi_545285"></i>
      )}

      {/* Banner con el título del recurso */}
      <div ref={vRef} className="recurso-titulo-texto">{recurso.nombre_recurso}</div>

      {/* Ícono de descarga */}
      {loadingId === recurso.id_recurso ? (
        <div className="spinner"></div>
      ) : (
        <i
          className="fi fi-sr-download video-camera-alt-2"
          onClick={() =>
            handleDownload(recurso.id_recurso, recurso.nombre_recurso)
          }
          style={{ cursor: "pointer" }}
        ></i>
      )}
    </div>
  );
}
